import { withSBErrorHandling } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotLegacyPageImpl = {
    async removePage(page) {
        return withSBErrorHandling(() => ScanbotSDKPlugin.removeLegacyPage({ page: page }));
    },
    async removeAllPages() {
        return withSBErrorHandling(() => ScanbotSDKPlugin.removeAllLegacyPages());
    },
    async setDocumentImage(params) {
        return withSBErrorHandling(() => ScanbotSDKPlugin.setDocumentImageOnLegacyPage(params));
    },
    async refreshImageUris(pages) {
        return withSBErrorHandling(async () => {
            return (await ScanbotSDKPlugin.refreshImageUrisOnLegacyPage({ pages: pages })).result;
        });
    },
};
//# sourceMappingURL=LegacyPageImpl.js.map